<template lang="pug">
.text-md
  .text-xl.font-semibold.mt-8.mb-4 Upload CSV
  div Make sure to read the guidelines before proceeding
  v-card.mt-8.pa-6(outlined)
    v-card.pa-3.mb-8(color="#FFFAE6" flat)
      .text-lg.font-semibold.mb-4 Guidelines
      ol
        li.mb-2 The field Yezza requires are Name and Phone. Other fields are optional, but may be necessary for personalization, segmentation, or other features.
        li Clearly label each column in your import file so you can easily choose the field type during the import process. For example, if you have a column named "Contact Email Addresses," you'll know to choose the Email Address field type.
    .neutral500--text
      div Make sure your file is in .csv format.
      div If customer already exists, customer data will be updated
    v-row
      v-col(cols="12" md="6" sm="8")
        .d-flex.mt-4.align-center
          v-file-input.round-2xl(v-model="file" outlined show-size accept=".csv" prepend-icon placeholder="Choose a file" hide-details)
          v-btn.ml-2.button-md(depressed color="#EEEEEE" @click="browseFile") {{ $t('browse') }}
          input.d-none(type="file" accept=".csv" @change="onIncomeFileChange" ref="uploadInput")
    .mt-8 
      v-btn.button-md.white--text(@click="continueUpload" color="info500" depressed :loading="isUploading" :disabled="!file") {{ $t('continue') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['parentFile', 'type', 'os'],
  data: () => ({
    isUploading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    file: {
      get () {
        return this.parentFile
      },
      set (newValue) {
        this.$emit('update:parentFile', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    onIncomeFileChange (e) {
      this.file = null
      const files = e.target.files || e.dataTransfer.files
      if (files.length) { 
        this.file = files[0]
      }
    },
    browseFile () {
      this.$refs.uploadInput.click()
    },
    continueUpload () {
      this.isUploading = true
      const params = new FormData()
      params.append('file', this.file)
      this.$axios.post(`/connect/${this.company.slug}/${this.type}/import_csv/mapping`, params)
        .then(resp => {
          this.processMappingResponse(resp.data)
        })
        .catch(e => {
          if (e.response?.data?.file?.length > 0) {
            this.showMessage(['error', e.response.data.file[0]])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
          }
        })
        .finally(() => {
          this.isUploading = false
        })
    },
    processMappingResponse (responseData) {
      const fields = []
      responseData.default_fields.forEach(item => {
        item.type = "System"
        fields.push(item)
      })
      responseData.custom_fields.forEach(item => {
        item.type = "Custom"
        fields.push(item)
      })
      this.$store.commit('customers/setFields', fields)
      const rowLength = responseData.data[0].length
      if (rowLength <= 1) {
        this.showMessage(['error', 'Row data is empty'])
      } else {
        this.$emit('onContinue', responseData)
      }
    }
  }
}
</script>